module.exports = __webpack_public_path__ + "img/the_instructions.482a3d22.jpg";